module.exports = __webpack_public_path__ + "images/image_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/image_1.png
// module id = 130
// module chunks = 0